import { Chip, ChipProps } from "@mui/material"
import { ArticleResult } from "interface/article"

type PublicationTypeChipsProps = {
	publicationTypes: ArticleResult['publicationType']
} & ChipProps
export const PublicationTypeChips = ({
	publicationTypes,
	...others
}: PublicationTypeChipsProps) => {
	return publicationTypes?.map(publicationType => (
		<Chip
			key={publicationType.code}
			label={publicationType.name}
			{...others}
		/>
	)) ?? <></>
}